<template>
  <div class="checkMyPackage">
    <van-tabs v-model="active" type="card" color="#07c160">
      <van-tab title="快递查询" name="1"></van-tab>
      <van-tab title="取件记录" name="2"></van-tab>
    </van-tabs>
    <div class="search-bar">
      <van-search
        v-model="orderNum"
        @input="search"
        shape="round"
        placeholder="请输入单号"
      />
    </div>

    <div class="list">
      <List :getData="getIn" v-if="active == '1'" ref="list1" key="list1">
        <template v-slot:item="{ item }">
          <div class="list-item">
            <div class="head">
              <span class="title">快递单号：{{ item.orderNum }}</span>
              <span class="state">{{ item.state }}</span>
            </div>
            <div class="item">
              <span class="label">提货人：</span>
              <span class="value">{{ item.userName }}</span>
            </div>
            <!-- <div class="item">
              <span class="label">提货人电话：</span>
              <span class="value">{{ item.mobile }}</span>
            </div> -->
            <div class="item">
              <span class="label">快递公司：</span>
              <span class="value">{{ item.expressCompany }}</span>
            </div>
            <div class="item">
              <span class="label">货架号：</span>
              <span class="value">{{ item.rackNo }}</span>
            </div>
            <div class="item">
              <span class="label">入库时间：</span>
              <span class="value">{{ item.createTime }}</span>
            </div>
            <div class="item">
              <span class="label">移库时间：</span>
              <span class="value">{{ item.moveDbTime }}</span>
            </div>
            <!-- <div class="item">
              <span class="label">取件地址：</span>
              <span class="value">顺丰</span>
            </div> -->
            <div class="item" v-show="item.state == '已出库'">
              <span class="label">出库人：</span>
              <span class="value">{{ item.outUser }}</span>
            </div>
            <div class="item" v-show="item.state == '已出库'">
              <span class="label">出库人电话：</span>
              <span class="value">{{ item.outMobile }}</span>
            </div>
            <div
              class="item"
              v-show="
                item.state == '取件派送中' || item.state == '取件派送完成'
              "
            >
              <span class="label">待取人：</span>
              <span class="value">{{ item.agentUser }}</span>
            </div>
            <div
              class="item"
              v-show="
                item.state == '取件派送中' || item.state == '取件派送完成'
              "
            >
              <span class="label">代取人电话：</span>
              <span class="value">{{ item.agentMobile }}</span>
            </div>
          </div>
        </template>
      </List>
      <List :getData="getOut" v-else ref="list2" key="list2">
        <template v-slot:item="{ item }">
          <div class="list-img-item">
            <img :src="item.file" />
            <div class="right">
              <div class="item">
                <span class="label">快递单号：</span>
                <span class="value">{{ item.orderNum }}</span>
              </div>
              <div class="item">
                <span class="label">扫描时间：</span>
                <span class="value">{{ item.createTime }}</span>
              </div>
            </div>
          </div>
        </template>
      </List>
    </div>
    <div style="margin: 10px 16px">
      <van-button round block type="primary" native-type="submit" @click="goTo"
        >代取</van-button
      >
    </div>
  </div>
</template>

<script>
import * as http from "@/api/index.js";
import List from "../components/list.vue";
export default {
  name: "CheckMyPackage",
  data() {
    return {
      active: "1",
      // 单号
      orderNum: "",
    };
  },
  components: {
    List,
  },
  created() {
    document.title = "查询快递";
    http.login();
  },
  methods: {
    search() {
      this.$refs[`list${this.active}`].reset();
    },
    // 跳转代取
    goTo() {
      this.$router.push({
        path: "/",
      });
    },
    // 快递查询
    async getIn(query) {
      const { phone } = JSON.parse(localStorage.getItem("tokenVo"));
      const obj = {
        businessData: {
          mobile: phone,
        },
        ...query,
      };

      if (this.orderNum) {
        obj.orderNum = this.orderNum;
      }
      const { data } = await http.orderInQuery(obj);
      return { data: data.records, total: data.total };
    },
    // 查询出库
    async getOut(query) {
      const { phone } = JSON.parse(localStorage.getItem("tokenVo"));
      const obj = {
        businessData: {
          mobile: phone,
        },
        ...query,
      };

      if (this.orderNum) {
        obj.orderNum = this.orderNum;
      }
      const { data } = await http.orderOutQuery(obj);
      return { data: data.records, total: data.total };
    },
  },
};
</script>


<style scoped lang="scss">
.checkMyPackage {
  height: 100%;
  padding: 1rem;
  .list {
    height: calc(100% - 54px - 40px - 44px);
    overflow-y: auto;

    .list-item {
      padding: 1rem;
      margin-bottom: 20px;
      background-color: #fff;
      border-radius: 5px;
      border: 1px solid #ddd;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;

        .title {
          font-size: 1rem;
          font-weight: bold;
          color: #333;
        }

        .state {
          font-size: 0.875rem;
          color: #999;
        }
      }

      .item {
        display: flex;
        align-items: center;
        margin-top: 1rem;

        .label {
          color: #999;
        }

        .value {
          color: #333;
        }
      }
    }

    .list-img-item {
      padding: 1rem;
      margin-bottom: 20px;
      background-color: #fff;
      border-radius: 5px;
      border: 1px solid #ddd;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      display: flex;

      img {
        width: 50px;
        height: 50px;
        margin-right: 1rem;
      }

      .right {
        flex: 1;

        .item {
          .label {
            color: #999;
          }

          .value {
            color: #333;
          }
        }
      }
    }
  }
}
</style>